import React from "react";
import Interweave, { Filter } from "interweave";
import { UrlMatcher } from "interweave-autolink";
import {
  Heading,
  Text,
  Box,
  Table,
  Tr,
  Td,
  Tbody,
  Link,
  UnorderedList,
  OrderedList,
  ListItem,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import PropTypes from "prop-types";

class ParagraphFilter extends Filter {
  node(name, node) {
    if (name === "p") {
      node.setAttribute("style", "margin-top: 8px;");
    }
    return node;
  }
}

const convertHTML = (node, children) => {
  if (node.tagName === "TABLE") {
    return (
      <Box borderWidth="1px" borderRadius="lg">
        <Table variant="striped">{children}</Table>
      </Box>
    );
  }
  if (node.tagName === "TR") {
    return <Tr>{children}</Tr>;
  }
  if (node.tagName === "TD") {
    return (
      <Td
        colspan={node.getAttribute("colspan")}
        rowspan={node.getAttribute("rowspan")}
        up="0.5rem"
      >
        {children}
      </Td>
    );
  }
  if (node.tagName === "TBODY") {
    return <Tbody>{children}</Tbody>;
  }

  if (node.tagName === "UL") {
    return <UnorderedList>{children}</UnorderedList>;
  }
  if (node.tagName === "OL") {
    return <OrderedList>{children}</OrderedList>;
  }
  if (node.tagName === "LI") {
    return <ListItem>{children}</ListItem>;
  }
};

const TextBlock = (props) => {
  const { label, text, isHtml, doi } = props;
  if (!text || text === "" || text === "<p></p>") return null;

  const formattedText = isHtml ? (
    <Text textAlign="justify" fontFamily="Noto Serif, serif">
      {doi && (
        <Link
          href={`https://en.bio-protocol.org/cjrap.aspx?eid=${doi}`}
          isExternal
        >
          Request a detailed protocol
          <ExternalLinkIcon mx="2px" />
        </Link>
      )}
      <Interweave
        content={text}
        filters={[new ParagraphFilter()]}
        matchers={[new UrlMatcher("url")]}
        newWindow={true}
        transform={convertHTML}
      />
    </Text>
  ) : (
    <Text fontFamily="Noto serif, serif">{text}</Text>
  );

  return (
    <Box marginBottom="1rem">
      {label && (
        <Heading
          size="lg"
          fontWeight="normal"
          fontFamily="Noto sans, sans-serif"
        >
          {label}
        </Heading>
      )}

      {formattedText}
    </Box>
  );
};

TextBlock.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string.isRequired,
  isHtml: PropTypes.bool,
};

TextBlock.defaultProps = {
  label: null,
  isHtml: false,
};

export default TextBlock;
